import { render, staticRenderFns } from "./shopCommunityManage.vue?vue&type=template&id=2579f99e&scoped=true"
import script from "./shopCommunityManage.vue?vue&type=script&lang=js"
export * from "./shopCommunityManage.vue?vue&type=script&lang=js"
import style0 from "./shopCommunityManage.vue?vue&type=style&index=0&id=2579f99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2579f99e",
  null
  
)

export default component.exports